import React from 'react'
import DashboardClientInvitations from '@/modules/dashboard/view/dashboard-invitations/dashboard-client-invitations.component'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'
import { ModalBig } from '@/modules/base/components/modal'

const openClientInvitationsModal = () => {

  const getComponent = (onClose) => (
    <ModalBig
      open
      width={900}
      maxWidth={'lg'}
      onClose={onClose}
      // workaround to ensure that the modal is the last to open in the background
      slotProps={{
        root: {
          sx: { zIndex: 1200 },
        },
        paper: {
          sx: { zIndex: 1200 },
        },
      }}
    >
      <DashboardClientInvitations onModalClose={onClose} />
    </ModalBig>
  )

  renderElement(getComponent)
}

export default openClientInvitationsModal
